<template>
    <b-button-group class="float-right">
        <b-button   
            variant="success"
            @click="inserirFilial()"
            v-if="$temAcessoView('ADMIN-FILIAIS-01')"
            ><i class="fa fa-plus"></i> Nova filial</b-button
        >
    </b-button-group>
</template>

<script>

export default {
    methods: {
        inserirFilial() {
            this.$router.push({
                name: `${this.$route.name}_Inserir_Filial`,
                params: {
                    operacao: 'INSERIR'
                }
            })
        },
    }
}

</script>